import { ProductNames } from '@xbs/xbs-enums';
import xbsPlatformModule from '@xbs/xbs-platform-module';
import { getAppConfig } from '../../utils/configuration';

let platformModule;
export const getPlatformModule = async() => {
  const appConfig = getAppConfig();
  if (!platformModule) {
    //ToDo: The product names need to be replaced when we start using this request.
    platformModule = xbsPlatformModule.getInstance(ProductNames.ByName.Tpiq.Uuid, appConfig.xbsEnvironmentShort);
  }

  return platformModule;
};